((window, document) => {
    const loginForm = document.getElementById('login-form');
    const emailField = document.getElementById('login-email');

    if (loginForm) {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        const urlParamEmail =  urlParams.get('email');

        if (urlParamEmail) {
            document.getElementById('login-email').value = decodeURIComponent(urlParamEmail);
        }

        loginForm.addEventListener('submit', (e) => {
            if (emailField) {
                window.location.replace('/email-magic-link/?email=' + encodeURIComponent(emailField.value));
            } else {
                window.location.replace('/email-magic-link/');
            }
        })
    }
})(window, document);